// @flow
export const SERVICE_NAME = 'service.history'
